import memoize from 'lodash/memoize';

export const isServer = memoize(() => !(typeof window !== 'undefined' && window.document && window.document.createElement));
